import Vue from 'vue';
import marketplaceProduct from './../../transformers/marketplaceProduct';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(marketplaceProduct.fetch(errors));
};


export default (productId, marketplaceData) => (
  new Promise((resolve, reject) => {
    const data = new FormData();
    Object.keys(marketplaceData).map((k) => {
      data.append(k, marketplaceData[k]);
      return null;
    });
    Vue.$http
      .request({
        url: `/products/${productId}/marketplace`,
        data,
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/marketplaceProduct/store.js